import { Component, Input } from '@angular/core';

@Component({
  selector: 'adc-panel',
  templateUrl: './adc-panel.component.html',
  styleUrls: ['./adc-panel.component.scss'],
  standalone: false
})
export class AdcPanelComponent {
  loading: boolean = false;
  showMenuBool: boolean = false;
  fullscreenBool: boolean = false;
  minimizeBool: boolean = false;
  closePanelBool: boolean = false;
  editBool: boolean = false;
  searchBool: boolean = false;
  unpinBool: boolean = false;

  @Input('data') data: any;

  reload(panel: string) {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 2000);
    
    this.showMenuBool = false
  }

  fullscreen(panel: string) {
    this.fullscreenBool = !this.fullscreenBool;
  }

  minimize(panel: string) {
    this.minimizeBool =  !this.minimizeBool;
  }

  closePanel(panel: string) {
      this.closePanelBool = !this.closePanelBool;
  }

  editTitle(panel: string) {
    this.editBool = true;
    this.showMenuBool = false;
  }

  search(panel: string) {
    this.searchBool = !this.searchBool;
    this.showMenuBool = false;
  }

  showMenu(panelId: any) {
    this.showMenuBool = !this.showMenuBool;
  }

  unpin(panel: string) {
    this.unpinBool = !this.unpinBool;
  }
}
